<template>
  <div class="pk-rankings">
    <div class="search">
      <div class="title">
        <span>竞赛排行榜</span>
      </div>
      <div class="search-box">
        <el-input placeholder="填写学员账号"></el-input>
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-select  placeholder="">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary">查询</el-button>
      </div>
    </div>
    <div class="list-wrap">
      <div class="rank-item">
        <div class="title">
          <img src="https://www.word007.com/static/images/rankinglist/jiangpai.png" alt="">
          <div class="title-name">
            <span>100道题（得分）</span>
          </div>
        </div>
        <div class="list">
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">1</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">2</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">3</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming.png" alt="">
              <span class="rank-num">4</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming.png" alt="">
              <span class="rank-num">5</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rank-item">
        <div class="title">
          <img src="https://www.word007.com/static/images/rankinglist/jiangpai.png" alt="">
          <div class="title-name">
            <span>100道题（得分）</span>
          </div>
        </div>
        <div class="list">
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">1</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">2</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">3</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming.png" alt="">
              <span class="rank-num">4</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming.png" alt="">
              <span class="rank-num">5</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rank-item">
        <div class="title">
          <img src="https://www.word007.com/static/images/rankinglist/jiangpai.png" alt="">
          <div class="title-name">
            <span>100道题（得分）</span>
          </div>
        </div>
        <div class="list">
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">1</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">2</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming1.png" alt="">
              <span class="rank-num">3</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming.png" alt="">
              <span class="rank-num">4</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="image">
              <img src="https://www.word007.com/static/images/rankinglist/paiming.png" alt="">
              <span class="rank-num">5</span>
            </div>
            <div class="user">
              <div class="first-row">
                <span class="type">姓名：</span>
                <span class="value">吕玉婷</span>
              </div>
              <div>
                <span class="type">账号：</span>
                <span class="value">wdhjddw9172</span>
              </div>
            </div>
            <div class="report">
              <div class="first-row">
                <span class="type">耗时：</span>
                <span class="value">294s</span>
                <span class="type score">分数：</span>
                <span class="value">99</span>
              </div>
              <div>
                <i class="iconfont icon-sign-in"></i>
                <span class="value">2018/12/15</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  DatePicker,
  Input,
  Select,
  Option,
  Button,
  // Row,
  // Col,
} from 'element-ui';


export default {
  components: {
    // ElRow: Row,
    // ElCol: Col,
    ElDatePicker: DatePicker,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElButton: Button,
  },
  data() {
    return {
      options: [{
        value: '选项1',
        label: '1个',
      }, {
        value: '选项2',
        label: '3个',
      }, {
        value: '选项3',
        label: '6个',
      }, {
        value: '选项4',
        label: '9个',
      }],
    };
  },
  computed: {},
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .pk-rankings {
    padding: 20px;
    box-shadow: 0 0 8px $border-color;
    .search {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 2px solid $border-color;
      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .search-box {
        .el-input {
          display: inline-block;
          width: 180px;
          right: 10px;
        }
        .el-select, .el-date-editor{
          margin-right: 10px;
        }
      }
    }
    .list-wrap {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 20px;
      .rank-item {
        width: 30%;
        border: 1px solid $border-color;
        @media screen and (max-width: 1440px) {
          width: 48%;
          margin-bottom: 20px;
        }
        .title {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          line-height: 42px;
          font-size: $font-size-lg;
          background: $primary;
          color: #fff;
        }
        .list {
          .item {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 10px;
            border-bottom: 1px dotted $border-color;
            &:last-child {
              border-bottom: none;
            }
            .image {
              width: 50px;
              height: 50px;
              margin-right: 10px;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .rank-num {
                position: absolute;
                top: 6px;
                left: 21px;
                font-size: 18px;
                font-weight: bold;
                font-family: -webkit-pictograph;
              }
            }
            &:nth-child(1),&:nth-child(2),&:nth-child(3) {
              .image {
                .rank-num {
                  bottom: 5px;
                  top: unset;
                }
              }
            }
            .user,.report {
              font-size: $font-size;
              line-height: 20px;
              flex: 1;
              .first-row {
                margin-bottom: 10px;
              }
            }
            .report {
              text-align: right;
              .score {
                margin-left: 10px;
              }
              .iconfont {
                color: $primary;
                margin-right: 10px;
              }
            }
            .type {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
</style>
